import Axios from '@/Axios'

class PayorTypeService {
    async getPayorTypes(data = {}) {
        return await Axios.get('wms.wms.api.payor_type.get_payor_types', {
            params: data,
        })
    }

    async createPayorType(data) {
        return await Axios.post('wms.wms.api.payor_type.create_payor_type', data)
    }
    async deletePayorType(payor_type) {
        const transformedPayorType = payor_type.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.payor_type.delete_payor_types', { data: { payor_type:transformedPayorType } })
    }
}

export default new PayorTypeService()
